import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
import * as models from '@/models';
import { CoursePermissions as CPerm } from '@/permissions';
import { CourseSnippetsStore } from '@/store';
import * as utils from '@/utils';
import SnippetImport from './SnippetImport';
// @ts-expect-error: This component is not in typescript yet.
import SnippetManager from './SnippetManager';
const CourseSnippetImport = tsx.componentFactoryOf().create({
    name: 'course-snippet-import',
    props: {
        /** The course to import snippets into. */
        course: p(models.Course).required,
    },
    computed: {
        /** @returns True if the user can manage snippets in this course. */
        canManageSnippets() {
            return this.course.hasPermission(CPerm.can_manage_course_snippets);
        },
    },
    methods: {
        /** Handles the import completion by reloading the course snippets. */
        async handleImportComplete() {
            await CourseSnippetsStore.load({ courseId: this.course.id, force: true });
        },
    },
    /** @returns The import component or empty if no permission. */
    render() {
        return utils.ifOrEmpty(this.canManageSnippets, () => (<SnippetImport course={this.course} onImportComplete={() => this.handleImportComplete()}/>));
    },
});
export default tsx.component({
    name: 'snippet-settings',
    props: {
        /** The course for which to manage snippets, or Nothing for personal snippets. */
        course: p.ofType().required,
    },
    /** @returns The rendered settings. */
    render() {
        return (<div data-cy="snippet-settings" class="col-xl-12 p-0 space-y-4">
                <SnippetManager course={this.course.extractNullable()}/>
                {this.course
                .map(course => <CourseSnippetImport course={course}/>)
                .orDefault(utils.emptyVNode())}
            </div>);
    },
});
